/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type SubmitContactUsFormPublicPathParams = NonNullable<
  operations['submitContactUsFormPublic']['parameters']['path']
>;

export type SubmitContactUsFormPublicRequestBody = OperationRequestBodyContent<operations['submitContactUsFormPublic']>;

export interface Input extends SubmitContactUsFormPublicPathParams {
  apiVersion?: string;
  body: SubmitContactUsFormPublicRequestBody;
}

export async function submitContactUsFormPublic(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/contact-us/forms/{formId}/public-submit', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
